/* Carrusel de imágenes en la tarjeta de producto.
   Runs globally (loaded once from theme.liquid) for every product-grid-item
   card on the page: collection, Featured/Tab collections, related, search, etc.

   - Desktop: square arrows step through all images; hovering the card fades to
     the 2nd image and back to the 1st on leave.
   - Mobile: swipe to crossfade — but NOT when the card sits inside a product
     slider (.carousel__item), so the product slider keeps its own swipe.
   - Full-width progress bar pulses on image change; visible on hover (desktop).
*/
(function () {
  var isDesktop = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setIndex(stack, i, pulse) {
    var slides = stack.querySelectorAll('[data-pgi-slide]');
    var n = slides.length;
    if (n === 0) return;
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    stack.__i = i;

    for (var k = 0; k < n; k++) {
      slides[k].classList.toggle('is-active', k === i);
    }

    var wrap = stack.parentElement;
    if (!wrap) return;

    var thumb = wrap.querySelector('[data-pgi-bar]');
    if (thumb && n >= 2) {
      thumb.style.width = (100 / n) + '%';
      thumb.style.transform = 'translateX(' + (i * 100) + '%)';
    }

    var prev = wrap.querySelector('[data-pgi-prev]');
    var next = wrap.querySelector('[data-pgi-next]');
    if (prev) prev.toggleAttribute('data-pgi-hidden', i <= 0);
    if (next) next.toggleAttribute('data-pgi-hidden', i >= n - 1);

    if (pulse) {
      var bar = wrap.querySelector('.pgi-swipe__bar');
      if (bar) {
        bar.classList.add('is-visible');
        if (stack.__barT) clearTimeout(stack.__barT);
        stack.__barT = setTimeout(function () { bar.classList.remove('is-visible'); }, 1100);
      }
    }
  }

  function initStack(stack) {
    if (stack.__pgiInit) return;
    stack.__pgiInit = true;
    var wrap = stack.parentElement;
    stack.__i = 0;
    setIndex(stack, 0);

    var card = stack.closest('.product-grid-item');
    var inSlider = card && card.classList.contains('carousel__item');

    if (isDesktop && wrap) {
      var prev = wrap.querySelector('[data-pgi-prev]');
      var next = wrap.querySelector('[data-pgi-next]');
      if (prev) prev.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        setIndex(stack, stack.__i - 1, true);
      });
      if (next) next.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        setIndex(stack, stack.__i + 1, true);
      });

      var imageWrap = stack.closest('.product-grid-item__image') || wrap;
      imageWrap.addEventListener('mouseenter', function () {
        if (stack.__i === 0) setIndex(stack, 1);
      });
      imageWrap.addEventListener('mouseleave', function () {
        setIndex(stack, 0);
      });
    } else if (!isDesktop && !inSlider) {
      // Mobile grid (not a product slider): swipe between images.
      var x0 = null, y0 = null, swiped = false;
      stack.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; swiped = false;
      }, { passive: true });
      stack.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          setIndex(stack, stack.__i + (dx < 0 ? 1 : -1), true);
          swiped = true;
        }
        x0 = null;
      }, { passive: true });
      stack.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pgi-stack]').forEach(initStack);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // Catch cards added later (filtering, infinite scroll, tab switches, quick view).
  if (window.MutationObserver) {
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; initAll(); });
    });
    var start = function () {
      if (document.body) obs.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
